module.exports = __webpack_public_path__ + "gn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gn.svg
// module id = 573
// module chunks = 0